import { persistStore } from 'redux-persist';
import { Cookies } from 'react-cookie';
import { notification } from 'antd';

import { store } from 'src/store';
import { Notification } from 'src/utils';

const showValidationMessages = (payload: unknown) => {
  if (Array.isArray(payload)) {
    payload.forEach((message) => {
      if (typeof message === 'string' && message.trim()) {
        Notification.error({ message });
      }
    });
    return true;
  }

  if (typeof payload === 'string' && payload.trim()) {
    Notification.error({ message: payload });
    return true;
  }

  if (payload && typeof payload === 'object') {
    Object.values(payload as Record<string, unknown>).forEach((value) => {
      const message = Array.isArray(value) ? value[0] : value;
      if (typeof message === 'string' && message.trim()) {
        Notification.error({ message });
      }
    });
    return true;
  }

  return false;
};

const request = {
  errors: (e: any) => {
    const status = e.response?.status;
    const data = e.response?.data;

    if (status) {
      switch (status) {
        case 403:
          return notification.error({
            message: 'Ocorreu um erro',
            description:
              'Parece que seu usuário não tem permissão para executar essa ação/ou acessar essa página.',
            duration: 0,
          });
        case 422: {
          const validationPayload = data?.message ?? data?.errors;

          if (showValidationMessages(validationPayload)) {
            return;
          }

          return Notification.error({
            message:
              'Ocorreu um erro ao processar essa ação, tente novamente mais tarde!',
          });
        }
        case 401:
          const cookies = new Cookies();

          cookies.set('_jwtToken', undefined, {
            path: '/',
            maxAge: 0,
          });

          return !!store.getState().auth.token
            ? persistStore(store)
                .purge()
                .then(() => {
                  window.location.reload();
                  Notification.error({
                    message: 'Sessão expirada!',
                  });
                })
            : Notification.error({
                message:
                  'Sessão expirada! Insira as suas credenciais e logue novamente, por favor.',
              });
        default:
          return Notification.error({
            message:
              'Ocorreu um erro ao processar essa ação, tente novamente mais tarde!',
          });
      }
    } else {
      return Notification.error({
        message:
          'Ocorreu um erro ao processar essa ação, tente novamente mais tarde!',
      });
    }
  },
};

export default request;
